<template>
  <div
    class="lg:py-0 md:py-0 lg:mb-0 md:mb-0 mb-12 md:mt-0 lg:mt-0 md:mt-0 mt-10"
  >
    <div class="">
      <div class="relative lg:flex md:flex">
        <!-- <div class="absolute bg-design15 mob-hidden">
          <img
            src="../../../assets/images/dots.svg"
            alt="bg-polygon"
            class="h6rem"
          />
        </div> -->
        <div class="absolute bg-design17 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>

        <div class="bgcceff2 rounded10rem lg:w-1/2 md:w-1/2 w-full py-8 z-10">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/Wellwisher%20page%20-%20volunteer.jpg"
            alt=""
            class="lg:w-3/5 md:w-3/5 lg:px-0 md:px-0 px-4 custborderradius mx-auto"
          />
        </div>
        <div
          class="lg:w-1/2 md:w-1/2 m-auto lg:px-0 md:px-0 px-4 lg:pt-0 md:pt-0 pt-8"
        >
          <div class="lg:px-12 md:px-12">
            <p class="subtitle lh32px sm-fsize14">
              You can add value to the lives of caregivers in need by committing
              your time and expertise.
            </p>
            <div class="lg:pt-8 md:pt-8 pt-4">
              <!-- <a
                target="_blank"
                class="hover:text-white"
                href="https://forms.office.com/r/vctepmjfcA"
              > -->
              <base-button
                type="primary"
                class="btntext"
                @click="handleRoute('request-form', 'work-at-cgs')"
                >Volunteer Now</base-button
              >
              <!-- </a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      partners: [
        {
          image: require("@/assets/images/ta.png"),
        },
        {
          image: require("@/assets/images/tc.png"),
        },
        {
          image: require("@/assets/images/e2.png"),
        },
        {
          image: require("@/assets/images/cl.png"),
        },
        {
          image: require("@/assets/images/BI.png"),
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleRoute(name, route) {
      this.$router.push({
        name: name,
        params: {
          pathName: route,
        },
      });
    },
  },
};
</script>
